import { render, staticRenderFns } from "./ConfiguratorStartSchwedt.vue?vue&type=template&id=e4c04472&scoped=true"
import script from "./ConfiguratorStartSchwedt.vue?vue&type=script&lang=js"
export * from "./ConfiguratorStartSchwedt.vue?vue&type=script&lang=js"
import style0 from "./ConfiguratorStartSchwedt.vue?vue&type=style&index=0&id=e4c04472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c04472",
  null
  
)

export default component.exports